exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v--modal-overlay .v--modal-box{max-height:90vh}", ""]);

// exports
